import React, { useEffect } from "react";
import useStore from "../../../../context/useStore";
import { FilterField, FilterGroup, FilterPanel, ListSearchForm } from "../../../common/DataList";
import useManagers from "../../../Hooks/useManagers/useManagers";
import useCERList from "../useCERList";

// Critères de la liste des CER : mêmes clés et mêmes valeurs qu'avant
// (cers/search) ; statut en cases à cocher, secteur en options jointes (avec
// « Tous » pour revenir sans secteur), raccourcis « Mes CER… » en boutons.
export const definitionsCER = ({ CER_STATUSES = [], ZONES = [] } = {}, managers = []) => [
  { name: "status", group: "contrat", label: "Statut", type: "multi", options: CER_STATUSES },
  {
    name: "userManager",
    group: "contrat",
    label: "Référent unique",
    type: "select",
    size: "lg",
    dataLabel: "fullName",
    options: managers.filter((m) => ["MANAGER", "AGENT_CAF_TS"].includes(m.role)),
  },
  { name: "beginAt", group: "dates", label: "Début du contrat", type: "date" },
  { name: "endAt", group: "dates", label: "Fin du contrat", type: "date" },
  { name: "zone", group: "allocataire", label: "Secteur", type: "segmented", firstOptionLabel: "Tous", options: ZONES },
  { name: "isUnderage", group: "allocataire", label: "N'afficher que les mineurs", type: "checkbox" },
];

const GROUPES = [
  { id: "contrat", title: "Contrat" },
  { id: "dates", title: "Dates" },
  { id: "allocataire", title: "Allocataire" },
];

const CERListFilters = () => {
  const [state] = useStore();
  const constants = state.constants.items || {};
  const { cerListFilters, actions, isSearchingCerList } = useCERList();
  const { managers, getManagers } = useManagers();

  useEffect(() => {
    getManagers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Valeur posée directement (cases du statut, croix d'une date) : même mise
  // à jour qu'une saisie.
  const poser = (name, value) => actions.updateCerListFilters({ target: { name, value } });
  const definitions = definitionsCER(constants, managers);

  return (
    <ListSearchForm onSubmit={() => actions.getCerList({})} aria-label="Recherche de contrats CER">
      <FilterPanel
        id="cer-list-filters"
        title="Filtres"
        onReset={actions.resetCerListFilters}
        resetLabel="Retirer les filtres"
        applyLabel="Rechercher"
        isLoading={isSearchingCerList}
      >
        {GROUPES.map((groupe) => (
          <FilterGroup key={groupe.id} title={groupe.title}>
            {definitions
              .filter((d) => d.group === groupe.id)
              .map((definition) => (
                <FilterField
                  key={definition.name}
                  definition={definition}
                  value={cerListFilters.filters[definition.name]}
                  values={cerListFilters.filters}
                  onChange={actions.updateCerListFilters}
                  onSet={poser}
                />
              ))}
          </FilterGroup>
        ))}
        <FilterGroup title="Raccourcis">
          <div className="filter-field filter-field--raccourcis">
            <button type="button" className="filter-field__raccourci" onClick={actions.filterByMyCER}>
              Mes CER
            </button>
            <button type="button" className="filter-field__raccourci" onClick={actions.filterByDraftCER2Months}>
              Mes CER non signés depuis 2 mois
            </button>
            <button type="button" className="filter-field__raccourci" onClick={actions.filterByDraftCERToEnd}>
              Mes CER qui arrivent à échéance dans 2 mois
            </button>
          </div>
        </FilterGroup>
      </FilterPanel>
    </ListSearchForm>
  );
};

export default CERListFilters;
